import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    display: 'flex',
    margin: '0 0 12px',
    width: '100%',
    maxWidth: '1080px',

    [mediaQueryHelper(breakpoint.tablet)]: {
      margin: '0 0 12px',
    },
  }),
  thankYouWrapper: css({
    height: '100%',
    overflowY: 'hidden',
    display: 'flex',
    padding: 0,
  }),
  bannerContainer: css({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#F8f0f6',
    border: 'solid',
    borderWidth: '1px',
    borderRadius: 3,
    borderColor: 'rgba(189, 105, 200, .3)',
    padding: '24px',

    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '100%',
    },
    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
      padding: '16px 24px',
      gap: '16px',
    },
  }),
  bannerIcon: css({
    height: 55,
    display: 'none',

    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'block',
    },
  }),
  bannerHeading: css({
    fontSize: '18px',
    fontWeight: 600,
    color: '#132254',
    margin: '0 0 6px',
    lineHeight: 1.2,
    textAlign: 'left',

    [mediaQueryHelper(breakpoint.phone)]: {
      margin: '0',
    },
  }),
  bannerContent: css({
    fontSize: '16px',
    color: '#5c5c5c',
    margin: '0 0 16px',
    lineHeight: 1.4,

    [mediaQueryHelper(breakpoint.phone)]: {
      margin: 0,
    },
  }),
  bannerButton: css({
    fontSize: '16px',
    backgroundColor: '#ba69c8',
    color: '#fff',
    border: 'none',
    height: 45,
    display: 'flex',
    margin: 'auto 0 auto auto',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
    borderRadius: 3,
    lineHeight: 1.4,
    padding: '6px 12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease-out',
    fontFamily: 'proxima-nova',

    '&:hover': {
      backgroundColor: '#974ca4',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      maxWidth: '130px',
    },
  }),
  formHeader: css({
    padding: '0 24px',
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '1.2',
  }),
  closeButton: css({
    background: 'transparent',
    padding: '8px 8px 5px',
    border: 'none',
    outline: 'none',
    transition: 'background 0.2s ease-out 0s',
    cursor: 'pointer',
    margin: '0 0 0 auto',

    [mediaQueryHelper(breakpoint.phone)]: {
      margin: '0 0 0px auto',
    },
  }),
  formContainer: css({
    background: '#fff',
    display: 'flex',
  }),
  formHeading: css({
    color: '#132254',
    fontSize: '24px',
    fontWeight: '700',
    margin: '0 0 8px',
  }),
  formImage: css({
    width: '100%',
    margin: '0 0 16px',
  }),
}

export default styles
